import './Projects.css';
import { useEffect, useState } from 'react';
import { NavigateFn, Project } from '../../utils/interfaces/types';
import { ProjectItem } from './ProjectItem';
import { useProjects } from '../../context/ProjectsContext';

export interface IProjects {
  navigate: NavigateFn;
  projects: Project[];
}

export function Projects(props: IProjects) {
  const { projects, isLoading, error, loadProjects } = useProjects();
  const [minDelayDone, setMinDelayDone] = useState(false);

  useEffect(() => {
    const delay = new Promise<void>((resolve) =>
      setTimeout(() => {
        setMinDelayDone(true);
        resolve();
      }, 1200),
    );
    Promise.all([loadProjects(), delay]);
  }, [loadProjects]);

  if ((isLoading && projects.length === 0) || !minDelayDone) {
    return (
      <div className="projects--loading">
        <div className="loader"></div>
      </div>
    );
  }

  if (error) {
    return <div className="projects projects--error"></div>;
  }

  return (
    <div className="projects">
      <h1 className="projects__title">Selected projects</h1>
      <div className="projects__list">
        {projects
          .filter((project) => project.visible)
          .map((project) => (
            <ProjectItem
              key={project.id}
              navigate={props.navigate}
              project={project}
            />
          ))}
      </div>
    </div>
  );
}
